import { createSelector } from '@reduxjs/toolkit';
import { ACCOUNT_FEATURE, USER_ROLE } from '@socialive/common';
import { selectFeature } from '@socialive/features';
import { selectAccountRole } from '~/store/accountInfo';

export default createSelector(
  selectFeature(ACCOUNT_FEATURE.SECURE_DOWNLOADS),
  selectAccountRole,
  ([treatment], accountRole) =>
    treatment === 'enabled' || (treatment === 'adminOnly' && accountRole === USER_ROLE.ADMIN)
);
